import { onUnmounted } from 'vue';
import * as PIXI from 'pixi.js';


export const cleanupPixiAppOnUnmount = (pixiApp: PIXI.Application) => {
  onUnmounted(() => {
    try {
      pixiApp.stop();
      pixiApp.destroy(true, {
        children: true,
      });
      if (pixiApp.canvas.parentNode) {
        pixiApp.canvas.parentNode.removeChild(pixiApp.canvas);
      }
    }catch (e){

    }
  });
}